<template>
    <div id="unreceived">
        <h3>Terima</h3>
        
        <!-- <pre>  {{ kontrasChecked }} </pre> -->


        <table class="table table-striped">
            <thead>
            <tr>
                <th></th>
                <th>Marking</th>
                <th>Invoice</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="kontra in kontras">
                <td >
                <input type="checkbox" 
                    :id="(kontra.id)" 
                    :value="(kontra.id)"
                    v-model="kontrasChecked" >
                    
                </td>
                <td>                    
                    <label :for="(kontra.id)">
                        {{ kontra.invoices[0].packaging_list.markingcode }}
                    </label>
                </td>       
                <td>
                    <ul>
                        <li v-for="(invoice, index) in kontra.invoices">
                        {{ invoice.invoiceid }}
                        </li>
                    </ul>                
                </td>         
            </tr>
            </tbody>
        </table>
        <div 
            v-if="kontrasChecked.length > 0"
            class="footer">
            <button class="btn btn-primary" @click="setReceived">Terima</button>
        </div>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'

import _ from 'lodash'

export default {
    data: () => ({
        kontras : [],
        kontrasChecked : []
    }),

    methods: {
            getPrinted: function(){
              HTTP
                .get('kontra/printed')
                .then(response => {
                  this.kontras = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },

            setReceived: function(){
              HTTP
                .post('kontra/received', {
                  kontras: this.kontrasChecked
                })
                .then(response => {
                  //console.log(response.data)
                  this.getPrinted();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            }
    },

  created() {
    this.getPrinted();
  }
}

</script>
<style>
#unreceived{
    padding: 10px;
    margin-bottom:50px;
}

</style>



// WEBPACK FOOTER //
// KontraReceived.vue?1346be4b